var exports = {
  "k": "xdbfd91f1--de6207--container",
};

module.exports = exports;
